import React from "react";
import { Pencil, Trash2 } from "lucide-react";

export default function ImportProfilesPanel({ profiles, selectedProfileId, matchedProfileId, isAdmin, onSelect, onDelete }) {
  return (
    <aside className="bg-white border border-slate-200 rounded-md p-4 h-fit" data-testid="import-profiles-panel">
      <div className="text-xs font-semibold uppercase tracking-[0.1em] text-slate-500 mb-3">Saved mapping profiles</div>
      {profiles.length === 0 && (
        <div className="text-xs text-slate-400 italic">No saved profiles yet. Map a file once, then save it to reuse the layout next time.</div>
      )}
      <div className="space-y-2 max-h-96 overflow-y-auto">
        {profiles.map((p) => {
          const active = p.id === selectedProfileId;
          const matched = p.id === matchedProfileId;
          return (
            <div
              key={p.id}
              className={`border rounded-md p-2.5 text-xs transition ${
                active ? "border-[#005E82] bg-slate-50" : matched ? "border-emerald-300" : "border-slate-200"
              }`}
              data-testid={`import-profile-${p.id}`}
            >
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <div className="font-medium text-slate-900 truncate">
                    {p.name}
                    {p.builtin ? " (built-in)" : ""}
                  </div>
                  {p.description && <div className="text-slate-500 mt-0.5 truncate">{p.description}</div>}
                  <div className="text-slate-400 mt-0.5">uses headers: {p.headers?.length || 0}</div>
                </div>
                {!p.builtin && (
                  <div className="flex items-center gap-1 shrink-0">
                    <button
                      type="button"
                      onClick={() => onSelect(p.id)}
                      className="text-slate-500 hover:text-[#005E82] p-1"
                      title="Edit"
                      data-testid={`import-profile-edit-${p.id}`}
                    >
                      <Pencil size={13} />
                    </button>
                    {isAdmin && (
                      <button
                        type="button"
                        onClick={() => onDelete(p)}
                        className="text-slate-500 hover:text-rose-600 p-1"
                        title="Delete"
                        data-testid={`import-profile-delete-${p.id}`}
                      >
                        <Trash2 size={13} />
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </aside>
  );
}
